import type { HiddenFieldType } from '@/src/Types/GF/Fields';

type Props = {
	field: HiddenFieldType;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function HiddenField({ field }: Props) {
	return <></>;
}
